const TRANSACTION_TYPES = {
	AUTO_REFUNDS: 'AUTO_REFUNDS',
	TOURNAMENT_FEE: 'TOURNAMENT_FEE',
	WINNINGS: 'WINNINGS',
	REWARD_KYC: 'REWARD_KYC',
	BONUS_EXPIRY: 'BONUS_EXPIRY',
	NOT_APPLICABLE: 'NOT_APPLICABLE',
	BONUS_CASHBACK_PARTNER: 'BONUS_CASHBACK_PARTNER',
	REWARD_OTHERS: 'REWARD_OTHERS',
	REFERRAL_CASHBACK_SIGNUP: 'REFERRAL_CASHBACK_SIGNUP',
	REFERRAL_CASHBACK_FD: 'REFERRAL_CASHBACK_FD',
	TOURNAMENT_FEE_CG: 'TOURNAMENT_FEE_CG',
	TOURNAMENT_FEE_MTT: 'TOURNAMENT_FEE_MTT',
	WINNINGS_CG: 'WINNINGS_CG',
	WINNINGS_MTT: 'WINNINGS_MTT',
	REWARD_CHALLENGE: 'REWARD_CHALLENGE',
	REWARD_WEB_PUSH: 'REWARD_WEB_PUSH',
	REWARD_HOME_SCREEN: 'REWARD_HOME_SCREEN',
	REWARD_TELEGRAM: 'REWARD_TELEGRAM',
	REWARD_WHATSAPP: 'REWARD_WHATSAPP',
	REWARD_APP_USAGE: 'REWARD_APP_USAGE',
	DEPOSITS_TO_WINNINGS: 'DEPOSIT_TO_WINNINGS',
	MISCELLANEOUS_BONUS: 'MISCELLANEOUS_BONUS',
	EXPIRY_CASHBACK_CREDIT: 'EXPIRY_CASHBACK_CREDIT',
	EXPIRY_CASHBACK_DEBIT: 'EXPIRY_CASHBACK_DEBIT',
	COINS_ADDED: 'COINS_ADDED',
	WITHDRAWAL: 'WITHDRAWAL',
	SIGNUP_CASHBACK: 'SIGNUP_CASHBACK',
	DEPOSIT_COUPON_CASHBACK: 'DEPOSIT_COUPON_CASHBACK',
	BONUS_COUPON_CASHBACK: 'BONUS_COUPON_CASHBACK',
	DEPOSIT_CASHBACK_PARTNER: 'DEPOSIT_CASHBACK_PARTNER',
	REFERRAL_CASHBACK_NO_OF_GAMES: 'REFERRAL_CASHBACK_NO_OF_GAMES',
	REFERRAL_CASHBACK_NO_OF_DAYS: 'REFERRAL_CASHBACK_NO_OF_DAYS',
	COINS_ADDED_PENDING: 'COINS_ADDED_PENDING',
	OTHERS: 'OTHERS',
	GST: 'GST',
	PWF_ENTRY_FEE: 'PWF_ENTRY_FEE',
	SUPER_SIX: 'SUPER_SIX',
	SUPER_SIX_LOTTERY: 'SUPER_SIX_LOTTERY'
};

const TRANSACTION_TYPES_MAP = {
	21006: TRANSACTION_TYPES.REFERRAL_CASHBACK_NO_OF_DAYS,
	21005: TRANSACTION_TYPES.REFERRAL_CASHBACK_NO_OF_GAMES,
	29003: TRANSACTION_TYPES.DEPOSIT_CASHBACK_PARTNER,
	29002: TRANSACTION_TYPES.DEPOSIT_CASHBACK_PARTNER,
	31003: TRANSACTION_TYPES.BONUS_CASHBACK_PARTNER,
	31002: TRANSACTION_TYPES.BONUS_CASHBACK_PARTNER,
	31001: TRANSACTION_TYPES.BONUS_COUPON_CASHBACK,
	29001: TRANSACTION_TYPES.DEPOSIT_COUPON_CASHBACK,
	21004: TRANSACTION_TYPES.REFERRAL_CASHBACK_SIGNUP,
	21001: TRANSACTION_TYPES.REFERRAL_CASHBACK_FD,
	20015: TRANSACTION_TYPES.REWARD_OTHERS,
	114: TRANSACTION_TYPES.GST,
	100: TRANSACTION_TYPES.COINS_ADDED_PENDING,
	58: TRANSACTION_TYPES.PWF_ENTRY_FEE,
	51: TRANSACTION_TYPES.WINNINGS_CG,
	50: TRANSACTION_TYPES.TOURNAMENT_FEE_CG,
	49: TRANSACTION_TYPES.TOURNAMENT_FEE_MTT,
	48: TRANSACTION_TYPES.WINNINGS_MTT,
	47: TRANSACTION_TYPES.REWARD_CHALLENGE,
	46: TRANSACTION_TYPES.REWARD_WEB_PUSH,
	45: TRANSACTION_TYPES.REWARD_HOME_SCREEN,
	44: TRANSACTION_TYPES.REWARD_TELEGRAM,
	43: TRANSACTION_TYPES.REWARD_WHATSAPP,
	42: TRANSACTION_TYPES.REWARD_APP_USAGE,
	41: TRANSACTION_TYPES.REWARD_KYC,
	40: TRANSACTION_TYPES.DEPOSITS_TO_WINNINGS,
	38: TRANSACTION_TYPES.WINNINGS,
	37: TRANSACTION_TYPES.TOURNAMENT_FEE,
	33: TRANSACTION_TYPES.NOT_APPLICABLE,
	27: TRANSACTION_TYPES.MISCELLANEOUS_BONUS,
	26: TRANSACTION_TYPES.MISCELLANEOUS_BONUS,
	25: TRANSACTION_TYPES.AUTO_REFUNDS,
	20: TRANSACTION_TYPES.BONUS_EXPIRY,
	19: TRANSACTION_TYPES.EXPIRY_CASHBACK_DEBIT,
	18: TRANSACTION_TYPES.EXPIRY_CASHBACK_CREDIT,
	16: TRANSACTION_TYPES.AUTO_REFUNDS,
	11: TRANSACTION_TYPES.COINS_ADDED,
	5: TRANSACTION_TYPES.WITHDRAWAL,
	0: TRANSACTION_TYPES.SIGNUP_CASHBACK,
	209: TRANSACTION_TYPES.SUPER_SIX,
	212: TRANSACTION_TYPES.SUPER_SIX_LOTTERY
};

const TRANSACTION_TYPES_LABEL = {
	[TRANSACTION_TYPES.COINS_ADDED_PENDING]: 'Coins Added (Pending)',
	[TRANSACTION_TYPES.REWARD_OTHERS]: 'Reward (Others)',
	[TRANSACTION_TYPES.TOURNAMENT_FEE]: 'Tournament Fee',
	[TRANSACTION_TYPES.WINNINGS]: 'Winnings',
	[TRANSACTION_TYPES.AUTO_REFUNDS]: 'Auto Refund',
	[TRANSACTION_TYPES.BONUS_EXPIRY]: 'Bonus Expiry',
	[TRANSACTION_TYPES.BONUS_CASHBACK_PARTNER]: 'Bonus Cashback (Partner)',
	[TRANSACTION_TYPES.REFERRAL_CASHBACK_SIGNUP]: 'Referral Cashback (SIGNUP)',
	[TRANSACTION_TYPES.REFERRAL_CASHBACK_FD]: 'Referral Cashback (FD)',
	[TRANSACTION_TYPES.WINNINGS_CG]: 'Winnings (CG)',
	[TRANSACTION_TYPES.TOURNAMENT_FEE_MTT]: 'Tournament Fee (MTT)',
	[TRANSACTION_TYPES.TOURNAMENT_FEE_CG]: 'Tournament Fee (CG)',
	[TRANSACTION_TYPES.WINNINGS_MTT]: 'Winnings (MTT)',
	[TRANSACTION_TYPES.REWARD_CHALLENGE]: 'Reward (Challenge)',
	[TRANSACTION_TYPES.REWARD_WEB_PUSH]: 'Reward (Web Push)',
	[TRANSACTION_TYPES.REWARD_HOME_SCREEN]: 'Reward (Home Screen)',
	[TRANSACTION_TYPES.REWARD_TELEGRAM]: 'Reward (Telegram)',
	[TRANSACTION_TYPES.REWARD_WHATSAPP]: 'Reward (whatsapp)',
	[TRANSACTION_TYPES.REWARD_APP_USAGE]: 'Reward (App Usage)',
	[TRANSACTION_TYPES.REWARD_KYC]: 'Reward (KYC)',
	[TRANSACTION_TYPES.EXPIRY_CASHBACK_DEBIT]: 'Expiry Cashback (Debit)',
	[TRANSACTION_TYPES.EXPIRY_CASHBACK_CREDIT]: 'Expiry Cashback (Credit)',
	[TRANSACTION_TYPES.DEPOSITS_TO_WINNINGS]: 'Deposits to Winning',
	[TRANSACTION_TYPES.NOT_APPLICABLE]: 'Not Applicable',
	[TRANSACTION_TYPES.MISCELLANEOUS_BONUS]: 'Miscellaneous Bonus',
	[TRANSACTION_TYPES.COINS_ADDED]: 'Coins Added',
	[TRANSACTION_TYPES.WITHDRAWAL]: 'Withdrawal',
	[TRANSACTION_TYPES.SIGNUP_CASHBACK]: 'Signup Cashback',
	[TRANSACTION_TYPES.OTHERS]: 'Others',
	[TRANSACTION_TYPES.DEPOSIT_COUPON_CASHBACK]: 'Deposit Coupon Cashback',
	[TRANSACTION_TYPES.BONUS_COUPON_CASHBACK]: 'Bonus Coupon Cashback',
	[TRANSACTION_TYPES.DEPOSIT_CASHBACK_PARTNER]: 'Deposit Cashback (Partner)',
	[TRANSACTION_TYPES.REFERRAL_CASHBACK_NO_OF_GAMES]: 'Referral Cashback (No of Games)',
	[TRANSACTION_TYPES.REFERRAL_CASHBACK_NO_OF_DAYS]: 'Referral Cashback (No of Days)',
	[TRANSACTION_TYPES.GST]: 'GST on Deposits',
	[TRANSACTION_TYPES.PWF_ENTRY_FEE]: 'PWF Entry Fee',
	[TRANSACTION_TYPES.SUPER_SIX]: 'Super Six',
	[TRANSACTION_TYPES.SUPER_SIX_LOTTERY]: 'Super Six Lottery'
};

const STATUS_TYPES_LABEL = {
	COMPLETE: 'Complete',
	PENDING: 'Pending'
};

type TransactionHistoryFilters = {
	from: number;
	to: number;
};

export const TRANSACTION_TYPE_OPTIONS: any[] = [
	{ label: 'All', id: 100 }
	// { label: 'Auto Refund', id: 25 },
	// { label: 'Tournament Fee', id: 37 },
	// { label: 'Winnings', id: 38 },
	// { label: 'Reward (KYC)', id: 41 },
	// { label: 'Bonus Expiry', id: 20 },
	// { label: 'Not Applicable', id: 33 },
	// { label: 'Bonus Cashback (Partner)', id: 31003 },
	// { label: 'Reward (Others)', id: 20015 },
	// { label: 'GST on Deposits', id: 114 },
	// { label: 'Coins Added (Pending)', id: 100 },
	// { label: 'PWF Entry Fee', id: 58 },
	// { label: 'Winnings (CG)', id: 51 },
	// { label: 'Tournament Fee (CG)', id: 50 },
	// { label: 'Tournament Fee (MTT)', id: 49 },
	// { label: 'Winnings (MTT)', id: 48 },
	// { label: 'Reward (Challenge)', id: 47 },
	// { label: 'Reward (Web Push)', id: 46 },
	// { label: 'Reward (Home Screen)', id: 45 },
	// { label: 'Reward (Telegram)', id: 44 },
	// { label: 'Reward (WhatsApp)', id: 43 },
	// { label: 'Reward (App Usage)', id: 42 },
	// { label: 'Referral Cashback (SIGNUP)', id: 21004 },
	// { label: 'Referral Cashback (FD)', id: 21001 },
	// { label: 'Referral Cashback (No of Games)', id: 21005 },
	// { label: 'Referral Cashback (No of Days)', id: 21006 },
	// { label: 'Deposits to Winning', id: 40 },
	// { label: 'Miscellaneous Bonus', id: 27 },
	// { label: 'Auto Refund', id: 16 },
	// { label: 'Coins Added', id: 11 },
	// { label: 'Withdrawal', id: 5 },
	// { label: 'Signup Cashback', id: 0 }
];

export { TRANSACTION_TYPES, TRANSACTION_TYPES_MAP, TRANSACTION_TYPES_LABEL, STATUS_TYPES_LABEL };
export type { TransactionHistoryFilters };
